import { Box, Button, Grid, Select } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { AiFillDelete, AiOutlineEdit } from 'react-icons/ai';
import { BsCheck2All } from 'react-icons/bs';
import KenLoader from '../../../../../../../Components/KenLoader';
import KenInputField from '../../../../../../../global_components/KenInputField';
import KenSelect from '../../../../../../../global_components/KenSelect';
import {
  deleteGradePointsSetup,
  getCustomGrade,
  postCustomGradeSetup,
} from '../../../../../../../Utils/apiServices';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SelectDefination from './SelectDefination';
import SelectGrade from './SelectGrade';
import SelectLetter from './SelectLetter';

const CustomLetterGrade = () => {
  const idGenerater = () => {
    let id = Math.random().toString(36).substr(2, 9);
    return id;
  };
  const [customGrade, setCustomGrade] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChangeLetterGrade = (e, id) => {
    setCustomGrade((pre) => {
      return pre.map((ele) => {
        if (ele.id === id) {
          return { ...ele, [e.target.name]: e.target.value };
        } else {
          return ele;
        }
      });
    });
  };

  const onSave = (id) => {
    setCustomGrade((pre) => {
      return pre.map((item) => {
        if (item.id === id) {
          return {
            ...item,

            isSaved: true,
          };
        } else {
          return { ...item };
        }
      });
    });
  };

  const onEditData = (id) => {
    setCustomGrade((pre) => {
      return pre.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            GradePoint: item.GradePoint,
            LetterGrade: item.LetterGrade,
            definition: item.definition,
            isSaved: false,
          };
        } else {
          return { ...item };
        }
      });
    });
  };

  const deleteHandle = (id) => {
    setCustomGrade((pre) => {
      const finaldata = pre.filter((data) => {
        if (id != data.id) {
          return data;
        }
      });
      return finaldata;
    });
  };

  const deleteRowHandle = (i) => {
    deleteGradePointsSetup(i)
      .then((res) => {
        getCustomGradingData();
        toast.success(`Data delete Successfully`);
      })
      .catch((err) => {
        console.log({ err });
        toast.error(`${err}`);
      });

    // setFacultyConferencesDetails((prev) => {
    //   console.log('prevprevprevprev', prev);
    //   return prev.filter((ab) => {
    //     console.log('ababababprevprevprevprev', ab, prev, i);
    //     return ab.id !== i;
    //   });
    // });
  };

  const addNewRow = (id) => {
    setCustomGrade((prev) => {
      return [
        ...prev,
        {
          // id: idGenerater(),
          GradePoint: '',
          LetterGrade: '',
          definition: '',
          isSaved: false,
        },
      ];
    });
  };

  const onSaveData = () => {
    const payload = customGrade?.map((prev) => {
      return {
        recordId: prev.id && prev.id,
        letterGrade: prev.LetterGrade,
        instituteId: '0015j00000rgtHcAAI',
        gradePoint: prev.GradePoint,
        definition: prev.definition,
      };
    });
    postCustomGradeSetup(payload)
      .then((res) => {
        getCustomGradingData();
        toast.success(`Data updated Successfully`);
      })
      .catch((err) => {
        toast.error(`${err}`);
        console.log(' Grading Course Details error', err);
      });
  };

  const getCustomGradingData = () => {
    setLoading(true);
    getCustomGrade()
      .then((res) => {
        setLoading(false);
        const data = res?.data?.map((item) => {
          return {
            id: item.recordId,
            GradePoint: item.gradePoint,
            LetterGrade: item.letterGrade,
            definition: item.definition,
            isSaved: true,
          };
        });
        setCustomGrade(data);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);

        console.log(' Grading Course Details error', err);
      });
  };
  useEffect(() => {
    getCustomGradingData();
  }, []);

  return (
    <div>
      {loading && <KenLoader />}
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Box>
        <Grid container>
          <Grid item xs={12} sm={3}>
            <span>
              <b>Grade Point</b>
            </span>
          </Grid>
          <Grid item xs={12} sm={3}>
            <span>
              <b>Letter grade</b>
            </span>
          </Grid>
          <Grid item xs={12} sm={3}>
            <span>
              <b>Defination</b>
            </span>
          </Grid>
          <Grid item xs={12} sm={2}>
            <span>
              <b>Edit</b>
            </span>
          </Grid>
          <Grid item xs={12} sm={1}>
            <span>
              <b>Delete</b>
            </span>
          </Grid>{' '}
          <Grid item xs={12} sm={1}>
            <span>
              <b></b>
            </span>
          </Grid>
        </Grid>{' '}
        {customGrade.map((item, index) => {
          return (
            <>
              <Grid container style={{ margin: '2px' }}>
                <Grid style={{ padding: '5px' }} item xs={12} sm={3}>
                  {item.isSaved ? (
                    item.GradePoint
                  ) : (
                    <SelectLetter />
                    // <KenInputField
                    //   optionalLabel={false}
                    //   name="GradePoint"
                    //   value={item.GradePoint}
                    //   onChange={(e) => onChangeLetterGrade(e, item.id)}
                    //   style={{ fontSize: 12 }}
                    // />
                  )}
                </Grid>
                <Grid item style={{ padding: '5px' }} xs={12} sm={3}>
                  {item.isSaved ? (
                    item.LetterGrade
                  ) : (
                    <SelectGrade />
                    // <KenInputField
                    //   // label={'Grad Point(CGPA)'}
                    //   optionalLabel={false}
                    //   name="LetterGrade"
                    //   value={item.LetterGrade}
                    //   onChange={(e) => onChangeLetterGrade(e, item.id)}
                    //   style={{ fontSize: 12 }}
                    // />
                  )}
                </Grid>
                <Grid item style={{ padding: '5px' }} xs={12} sm={3}>
                  {item.isSaved ? (
                    item.definition
                  ) : (
                    <SelectDefination
                      value={item.LetterGrade}
                      onChange={(e) => onChangeLetterGrade(e, item.id)}
                    />
                    // <KenInputField
                    //   // label={'Grad Point(CGPA)'}
                    //   optionalLabel={false}
                    //   name="definition"
                    //   value={item.definition}
                    //   onChange={(e) => onChangeLetterGrade(e, item.id)}
                    //   style={{ fontSize: 12 }}
                    // />
                  )}
                </Grid>
                {!item.isSaved ? (
                  <Grid style={{ padding: '5px' }} item xs={12} sm={2}>
                    <BsCheck2All
                      style={{ marginTop: '19px', cursor: 'pointer' }}
                      size={30}
                      onClick={() => onSave(item.id)}
                    />
                  </Grid>
                ) : (
                  <Grid style={{ padding: '5px' }} item xs={12} sm={2}>
                    <AiOutlineEdit
                      style={{ cursor: 'pointer' }}
                      size={23}
                      onClick={() => onEditData(item.id)}
                    />
                  </Grid>
                )}

                <Grid style={{ padding: '5px' }} item xs={12} sm={1}>
                  <AiFillDelete
                    style={{ marginTop: '0px', cursor: 'pointer' }}
                    size={22}
                    onClick={() => deleteRowHandle(item.id)}
                  />
                </Grid>
              </Grid>
              <Grid style={{ display: 'flex', float: 'right' }}>
                {' '}
                {customGrade.length - 1 === index && (
                  <>
                    {' '}
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => addNewRow(item.id)}
                    >
                      Add New
                    </Button>
                  </>
                )}
              </Grid>
            </>
          );
        })}
        <Button
          variant="contained"
          color="primary"
          style={{ marginTop: '30px' }}
          onClick={() => {
            onSaveData();
          }}
        >
          Save
        </Button>
      </Box>
    </div>
  );
};

export default CustomLetterGrade;
